import { releaseNotificationConstants } from "./constants/releaseNotificationConstant";

const releaseNotificationGetSetting = () => {
	return {
		type: releaseNotificationConstants.ReleaseNotificationSettingGetRequest,
		input: {}
	};
};

const releaseNotificationUpdateSetting = (data: any) => {
	return {
		type: releaseNotificationConstants.ReleaseNotificationSettingUpdateRequest,
		input: data
	};
};

export const releaseNotificationAction = {
	releaseNotificationGetSetting,
	releaseNotificationUpdateSetting
};
